var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary","disabled":_vm.isDisabled},on:{"click":_vm.saveAction}},[_vm._v(" Kaydet ")])}
var staticRenderFns = []

export { render, staticRenderFns }